import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";
// import css
import "flatpickr/dist/flatpickr.min.css";
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import dayjs from 'dayjs'

export default class extends Controller {
  connect() {
    flatpickr("#start_date", {
      locale: Russian,
      date_format: "d-m-Y",
      minDate: dayjs().startOf('date').toDate(),
      altInput: true,
      altFormat: "d-m-Y",
      altInputClass: "block w-full border-0 bg-transparent text-ink-800 placeholder:text-slate-500 focus:ring-0 outline-none text-base p-0",
      disableMobile: "true",
    });
    flatpickr("#end_date", {
      locale: Russian,
      date_format: "d-m-Y",
      minDate: dayjs().add(1, 'day').toDate(),
      altInput: true,
      altFormat: "d-m-Y",
      altInputClass: "block w-full border-0 bg-transparent text-ink-800 placeholder:text-slate-500 focus:ring-0 outline-none text-base p-0",
      disableMobile: "true",
    });
    // flatpickr("#start_time", {
    //   locale: Russian,
    //   date_format: "H:i",
    //   minDate: new Date(),
    //   altInput: true,
    //   altFormat: "d-m-Y",
    //   altInputClass: "block w-full border-y-0 border-l-0 border-r border-gray-800 text-gray-800 placeholder-gray-500 focus:ring-0 text-base"
    // });
    // flatpickr("#end_date", {
    //   locale: Russian,
    //   dateFormat: "d-m-Y",
    //   minDate: new Date(),
    // });
    // this.element.textContent = "Hello World!"
  }
  change_min_date() {
    let min_date = document.getElementById("start_date").value;
    flatpickr("#end_date", {
      locale: Russian,
      date_format: "d-m-Y",
      minDate: min_date ? dayjs(min_date, "YYYY-MM-DD").add(1, 'day').toDate() : dayjs().startOf('date').toDate(),
      altInput: true,
      altFormat: "d-m-Y",
      altInputClass: "block w-full border-0 bg-transparent text-ink-800 placeholder:text-slate-500 focus:ring-0 outline-none text-base p-0",
      disableMobile: "true",
    });
  }
}
